import { defineMessages } from 'react-intl.macro';
import moment from 'moment-timezone';
import uuid from 'uuid4';

export const isUndefined = val => val === undefined;

export const nowTime = () => Date.now();

export const numBetween = (lower, upper) =>
    Math.floor(Math.random() * (upper - lower + 1)) + lower;

export const isBeforeTimestamp = classStartTimestamp =>
    moment().isAfter(classStartTimestamp, nowTime());

export const adjustUnixTimestamp = unixTimestamp => unixTimestamp * 1000;

export const parseURIParams = uri =>
    uri.split('&').reduce((acc, set) => {
        const [key, val] = set.split('=');
        return { ...acc, [key]: val };
    }, {});

export const isDevelopment = () => process.env.NODE_ENV === 'development';

export const generateIdempotencyToken = () => uuid();

export const openTabBase = globals => url => {
    const newWindow = globals.open(url);
    newWindow.opener = null;
};

export const sleep = ms => {
    return new Promise(res => setTimeout(res, ms));
};

export const openTab = openTabBase(window);

export const getLabIdFromLabUrl = labUrl => {
    let parsed;
    try {
        parsed = new URL(labUrl);
    } catch (err) {
        console.error(`Invalid Lab URL: ${labUrl}`, err);
        return null;
    }
    const [, labId] = parsed.pathname.match(/^\/session\/(\w+)\/?/i);
    return labId;
};

const messages = defineMessages({
    hours: {
        id: 'timeDuration.hours',
        description: 'Amount of time in hours, pluralized',
        defaultMessage: '{amount} hours',
    },
    hour: {
        id: 'timeDuration.hour',
        description: 'A single hour',
        defaultMessage: '1 hour',
    },
    minutes: {
        id: 'timeDuration.minutes',
        description: 'Amount of time in minutes, pluralized',
        defaultMessage: '{amount} minutes',
    },
    minute: {
        id: 'timeDuration.minute',
        description: 'A single minute',
        defaultMessage: '1 minute',
    },
});

/**
 * (2, "hour", "en-US") => "2 hours"
 * (30, "minutes", "es-ES") => "30 minutos"
 * @param {number} value
 * @param {string} unit
 * @param {function} formatMessage
 * @returns string
 */
export const translateDurationUnit = (value, unit = 'min', formatMessage) => {
    const totalMinutes = Math.round(
        unit.startsWith('h') ? value * 60 : Number(value)
    );
    const hour = Math.floor(totalMinutes / 60);
    const min = totalMinutes % 60;
    const hourMsg =
        hour > 1
            ? formatMessage(messages.hours, { amount: hour })
            : hour === 1
            ? formatMessage(messages.hour)
            : '';
    const minuteMsg =
        min > 1
            ? formatMessage(messages.minutes, { amount: min })
            : min === 1
            ? formatMessage(messages.minute)
            : '';
    return `${hourMsg} ${minuteMsg}`.trim();
};

/**
 * function to check if a function is overflowing it's container
 * @param {HTMLElement} htmlNode
 * @returns {boolean}
 */
export const elementHasOverflown = htmlNode =>
    htmlNode.offsetHeight < htmlNode.scrollHeight - 1; // -1 is needed for Firefox
